class cardCarouselFilters extends HTMLElement {
  constructor() {
    super();
    this.embla = this.querySelector('embla-component');
    this.tags = this.querySelectorAll('.card-carousel-tag-js');
    this.cards = this.querySelectorAll('.card-carousel-js');

    if(this.tags.length > 0) {
      this.tags.forEach(tag => {
        tag.addEventListener('click', (e) => this.handleCardsToggle(e.target))
      })
    }
  }

  handleCardsToggle(clickedTag) {
    const currentType = clickedTag.getAttribute('data-type');
    if(!currentType || !this.embla) return;
    this.tags.forEach(tag => tag.classList.remove('button--tertiary--active'));
    clickedTag.classList.add('button--tertiary--active');
    this.cards = this.querySelectorAll('.card-carousel-js');
    this.cards.forEach(card => {
      if(card.getAttribute('data-type') === currentType) {
        card.classList.remove('card--hidden')
        card.classList.add('card--visible')
      }
      else {
        card.classList.remove('card--visible')
        card.classList.add('card--hidden')
      }
    })
    this.embla.goToStart();
  }
}
customElements.define('card-carousel-filters', cardCarouselFilters);
